import { Container, Text, TextStyle } from "pixi.js";

export class ShortInfo extends Container {
    private fpsText: Text;
    private heapText: Text;

    public constructor() {
        super();
        this.build();
        this.hide();
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    public updateData(fps: number, usedJSHeapSize: number, jsHeapSizeLimit: number): void {
        this.fpsText.text = `FPS: ${fps}`;
        this.heapText.text = `Heap usage: ${usedJSHeapSize}/${jsHeapSizeLimit}`;
    }

    private build(): void {
        this.fpsText = new Text("", new TelemetryInfoTextStyle());
        this.addChild(this.fpsText);

        this.heapText = new Text("", new TelemetryInfoTextStyle());
        this.addChild(this.heapText);

        this.fpsText.position.set(10, 0);
        this.heapText.position.set(10, this.fpsText.position.y + this.fpsText.height + 5);
    }
}

class TelemetryInfoTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 25,
            fill: 0xffffff,
            stroke: 0x000000,
            strokeThickness: 5
        })
    }
}